import React, { useEffect, useState } from "react";
import LoginSignup from "../../components/Login-signup/Frame";

import img1 from "../../assets/Login/ScrollFirst.png";
import img2 from "../../assets/Login/ScrollSecond.png";
import img3 from "../../assets/Login/ScrollThird.png";
import img4 from "../../assets/Login/ScrollSecondAR.png";
import img5 from "../../assets/Login/ScrollThirdAR.png";
import logo from "../../assets/Logo/logo.svg";
import { useTranslation } from "react-i18next";

const Signup = () => {
  const [current, setCurrent] = useState(0);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  const slides = [
    {
      image: img1,
      title: "Run and manage your shop easily",
    },
    {
      image: isRTL ? img4 : img2,
      title: "Update stock and products anytime",
    },
    {
      image: isRTL ? img5 : img3,
      title: "Track online + Cashier sales, all in one place",
    },
  ];
  return (
    <div className="flex min-h-screen bg-white overflow-hidden">
      {/* LEFT SLIDER */}
      <div className="hidden md:block w-1/2 relative overflow-hidden bg-[#E6EFFF]">
        {/* Fixed Logo */}
        <img
          src={logo}
          width={120}
          height={80}
          alt="myGINNE Logo"
          onClick={() =>
            window.open(`${process.env.REACT_APP_LANDING_PAGE_URL}`, "_blank")
          }
          style={{
            cursor: "pointer",
            top: "1.5rem",
            ...(isRTL
              ? { right: "1.5rem", left: "auto" }
              : { left: "1.5rem", right: "auto" }),
          }}
          className="absolute z-10"
        />

        {/* Sliding container */}
        <div
          className="flex flex-row w-full h-full transition-transform duration-1000 ease-in-out"
          style={{
            transform: `translateX(${isRTL ? current * 100 : -current * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <div
              key={index}
              className="min-w-full h-full relative flex flex-col justify-center items-center p-10"
            >
              <img
                src={slide.image}
                alt="slide"
                className="w-2/3 h-2/3 object-contain"
              />

              <div className="max-w-md mt-6">
                <h2 className="text-4xl font-bold mb-3 text-primaryBlue text-center leading-10">
                  {t(slide.title)}
                </h2>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT – LOGIN */}
      <div className="w-full md:w-1/2 flex items-center justify-start p-5 md:p-10">
        <div className="w-full max-w-full">
          <LoginSignup
            welcomeText="Welcome"
            subText="Join us and take your store to the next level!"
            login={false}
            belowText="Already have an account?"
          />
        </div>
      </div>
    </div>
  );
};

export default Signup;
